import { createFileRoute } from '@tanstack/react-router'
import { requireSystem } from '@/lib/auth-guards'
import { SystemCheckInPage } from '@/features/check-ins/system-checkin-page'

export const Route = createFileRoute('/_authenticated/system/check-ins')({
  beforeLoad: requireSystem,
  component: SystemCheckInPage,
})
